import * as Yup from "yup";

export const testimonialValidationSchema = Yup.object().shape({
  customerName: Yup.string().required("Customer name is required"),
  rating: Yup.number()
    .typeError("Rating must be a number")
    .required("Rating is required")
    .min(1, "Rating must be between 1 and 5")
    .max(5, "Rating must be between 1 and 5"),
  description: Yup.string().required("Description is required"),
  isActive: Yup.boolean(),
});
